




































































































import { EmployeApi } from "../api/EmployeApi";
import Pagination from "../core/UI/Pagination.vue";
import AbsenceModal from "../employe/AbsenceModal.vue";
import AbsenceNotificationModal from "./AbsenceNotificationModal.vue";
import { Employe } from "../models/Employe";
import Absence = Employe.Absence;
import moment from "moment";

export default {
    name: "AbsenceNotificationsList",
    components: { AbsenceNotificationModal, Pagination, AbsenceModal },
    data() {
        return {
            absences: [],
            EmployeApi: new EmployeApi(),
            currentPage: 1,
            totalPages: 1,
            selectedAbsenceEmployeId: null,
            selectedAbsenceId: null,
            absenceNotificationModal: {
                show: false,
                selectedAbsence: null,
            },
        };
    },
    created() {
        this.refreshAbsences();
    },
    methods: {
        loadPage(page: number) {
            let self = this;
            let params = {
                limit: 10,
                page: page,
                include: "journal_entry",
                max_date: moment().add(1, "week").format("YYYY-MM-DD"),
            };
            self.EmployeApi.getAllAbsences(params).then(function (response) {
                let { data, metadata, paginator } = response;
                self.absences = data;
                self.currentPage = paginator.current_page;
                self.totalPages = paginator.total_pages;
            });
        },
        refreshAbsences() {
            this.loadPage(this.currentPage);
        },
        // Modal edit
        editAbsence(absence: Absence) {
            let self = this;
            self.selectedAbsenceId = null;
            setTimeout(function () {
                self.selectedAbsenceEmployeId = absence.employe_id;
                self.selectedAbsenceId = absence.id;
            });
        },
        // Modal notification
        sendNotification(absence: Absence) {
            this.absenceNotificationModal.selectedAbsence = absence;
            this.absenceNotificationModal.show = true;
        },
        onAbsenceNotificationModalClose() {
            this.absenceNotificationModal.show = false;
            this.absenceNotificationModal.selectedAbsence = null;
            this.refreshAbsences();
        },
    },
};
